import React from "react";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import { Link } from "react-router-dom";
const PricingCards = () => {
  return (
    <div className="QL__Sec__PricingCards">
      <Container>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={3} textAlign="center">
            <Card
              className="QL__Sec__PricingCards__Cards"
            sx={{ minWidth: 210 }}
            >
              <CardContent>
                <Typography
                  sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={600}
                >
                  PLAN A
                </Typography>
                <Typography sx={{ mb: 5.5 }} variant="h6" fontWeight={500}>
                  2 DAYS PER WEEK
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  8 Lessons Per Month
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  4hrs Per Month
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  30 Minutes LIVE Lessons
                </Typography>
                <Typography
                  sx={{ mb: 3.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  100% Money Back Guarantee
                </Typography>
                <Typography
                  // sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={"bold"}
                  fontSize={40}
                  color="#1BB983"
                >
                  $30
                </Typography>
                <br />
                <Link style={{ textDecoration: "none" }} to="/Registration">
                  <Button className="Allbuttons" variant="contained">
                    Register Now
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3} textAlign="center">
            <Card
              className="QL__Sec__PricingCards__Cards"
            sx={{ minWidth: 210 }}
              // justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={600}
                >
                  PLAN B
                </Typography>
                <Typography sx={{ mb: 5.5 }} variant="h6" fontWeight={500}>
                  3 DAYS PER WEEK
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  12 Lessons Per Month
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  6hrs Per Month
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  30 Minutes LIVE Lessons
                </Typography>
                <Typography
                  sx={{ mb: 3.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  100% Money Back Guarantee
                </Typography>
                <Typography
                  // sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={"bold"}
                  fontSize={40}
                  color="#1BB983"
                >
                  $45
                </Typography>
                <br />
                <Link style={{ textDecoration: "none" }} to="/Registration">
                  <Button className="Allbuttons" variant="contained">
                    Register Now
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3} textAlign="center">
            <Card
              className="QL__Sec__PricingCards__Cards"
            sx={{ minWidth: 210 }}
              // justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={600}
                >
                  PLAN C
                </Typography>
                <Typography sx={{ mb: 5.5 }} variant="h6" fontWeight={500}>
                  4 DAYS PER WEEK
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  16 Lessons Per Week
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                 8hrs Per Month
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  30 Minutes LIVE Lessons
                </Typography>
                <Typography
                  sx={{ mb: 3.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  100% Money Back Guarantee
                </Typography>
                <Typography
                  // sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={"bold"}
                  fontSize={40}
                  color="#1BB983"
                  fontFamily="cabin"
                >
                  $60
                </Typography>
                <br />
                <Link style={{ textDecoration: "none" }} to="/Registration">
                  <Button className="Allbuttons" variant="contained">
                    Register Now
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3} textAlign="center">
            <Card
              className="QL__Sec__PricingCards__Cards"
            sx={{ minWidth: 210 }}
              // justifyContent="center"
            >
              <CardContent>
                <Typography
                  sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={600}
                >
                  PLAN D
                </Typography>
                <Typography sx={{ mb: 5.5 }} variant="h6" fontWeight={500}>
                  5 DAYS PER WEEK
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  20 Lessons Per Month
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                 10hrs Per Month
                </Typography>
                <Typography
                  sx={{ mb: 0.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  30 Minutes LIVE Lessons
                </Typography>
                <Typography
                  sx={{ mb: 3.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={500}
                  fontSize={17}
                >
                  100% Money Back Guarantee
                </Typography>
                <Typography
                  // sx={{ mb: 1.5 }}
                  variant="h5"
                  justifyContent="center"
                  fontWeight={"bold"}
                  fontSize={40}
                  color="#1BB983"
                  fontFamily="cabin"
                >
                  $75
                </Typography>
                <br />
                <Link style={{ textDecoration: "none" }} to="/Registration">
                  <Button className="Allbuttons" variant="contained">
                    Register Now
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Typography
          paddingTop={10}
          // sx={{ mb: 1.5 }}
          variant="h5"
          textAlign="center"
          justifyContent="center"
          fontWeight={500}
          fontSize={17}
          lineHeight={2}
        >
          We accept payments through Credit card, and Master card.
          <br />
          <span className="QL__PG__Pricing__text">Need Help?!</span>
        </Typography>
        <Typography textAlign="center" fontWeight={500} paddingTop={1}>
          <Link style={{ color: "#1BB983" }} to="/Contact">
            Contact Now
          </Link>
        </Typography>
      </Container>
    </div>
  );
};

export default PricingCards;
